import React, { Component }  from 'react'
import { Icon, Modal, Button, Tab, Table, Segment, Popup } from 'semantic-ui-react'
import { saveAs } from 'file-saver'

import moment from 'moment'
import axios from 'axios'
import find from 'lodash/find'
import constants from '../../constants';

const _ = { find }
const breakdownOfFees = constants.breakdownOfFees;
const tuitionFeeSched = constants.tuitionFeeSched;

class ApplicantsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
  }
  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  download = (fileName, module) => {
    axios({
      url: `${process.env.REACT_APP_URL}/assets/download?module=${module}&fileName=${fileName}`,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      saveAs(new Blob([response.data]), fileName);
    });
  }

  render() {
    let breakdownLevel, scheduleOfPayment, ue, amt;
    if (this.props.applicant.gradeLevel) {
      breakdownLevel = _.find(breakdownOfFees, {
        gradeLevel: this.props.applicant.gradeLevel
      });
    }

    if (this.props.applicant.paymentSchedule) {
      scheduleOfPayment = _.find(tuitionFeeSched, {
        gradeLevel: this.props.applicant.gradeLevel
      });

      if (this.props.applicant.paymentSchedule === 'Full Cash Basis') {
        ue = scheduleOfPayment.cash;
        amt = '';
      } else if (this.props.applicant.paymentSchedule === 'Semi-Annual'){
        ue = scheduleOfPayment.uponEnrollmentSemi;
        amt = scheduleOfPayment.semi;
      } else if (this.props.applicant.paymentSchedule === 'Quarterly'){
        ue = scheduleOfPayment.uponEnrollmentQuarterly;
        amt = scheduleOfPayment.quarterly;
      } else if (this.props.applicant.paymentSchedule === 'Monthly Basis'){
        ue = scheduleOfPayment.uponEnrollmentMonthly;
        amt = scheduleOfPayment.monthly;
      } else {
        ue = '';
        amt = '';
      }
    }
    const panes = [
      { menuItem: 'Demographics', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Name</strong>
                </Table.Cell>
                <Table.Cell><span>{this.props.applicant.lastName}, {this.props.applicant.firstName} {this.props.middleName}</span></Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Gender</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.gender}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Place of Birth</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.placeOfBirth}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Birthdate</strong>
                </Table.Cell>
                <Table.Cell>{moment(this.props.applicant.birthDate).format('MMM DD, YYYY')}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Religion</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.religion}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Contact Information', render: () =>
        <Tab.Pane>
          <h3>Personal Contact Information</h3>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Address</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.address}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Email</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.email}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Mobile 1</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.mobile1}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Mobile 2</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.mobile2}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <h3>Contact Information in case of Emergency</h3>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Person</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.contactPerson}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Person Number</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.contactPersonNumber}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Person Address</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.contactPersonAddress}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Other Details', render: () =>
        <Tab.Pane>
          <h4>Parents</h4>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Mother's Maiden Name</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.mother}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Father's Name</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.father}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <h4>Guardian</h4>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Name</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.guardianName}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Contact Number</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.guardianNumber}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Address</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.guardianAddress}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <h4>Others</h4>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Ethnicity</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.ethnicity}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Mother Tounge</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.motherTounge}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Other Spoken Languages</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.languages}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Medical', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Have Been Hospitalized?</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.beenHospitalized ? 'Yes' : 'No' }</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Reason</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.hospitalReason}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Medical History</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.medicalHistory}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Tab.Pane> },
      { menuItem: 'Enrollment Information', render: () =>
        <Tab.Pane>
          <Table basic='very' celled size='small'>
            <Table.Body>
              {
                this.props.applicationType === 'new' &&
                <>
                  <Table.Row>
                    <Table.Cell collapsing>
                      <strong>Previous School Name</strong>
                    </Table.Cell>
                    <Table.Cell>{this.props.applicant.prevSchoolName }</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell collapsing>
                      <strong>Previous School Address</strong>
                    </Table.Cell>
                    <Table.Cell>{this.props.applicant.prevSchoolAddress}</Table.Cell>
                  </Table.Row>
                </>
              }

              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Grade Level</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.gradeLevel}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Payment Schedule</strong>
                </Table.Cell>
                <Table.Cell>{this.props.applicant.paymentSchedule}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Form 137(Report Card)</strong>
                </Table.Cell>
                <Table.Cell>
                  <span className='file-link' onClick={()=>this.download(this.props.applicant.gradeFilename, 'reportCard')}>
                    {this.props.applicant.gradeFilename}
                  </span>
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell collapsing>
                  <strong>Requirements</strong>
                </Table.Cell>
                <Table.Cell>
                  <span className='file-link' onClick={()=>this.download(this.props.applicant.filename, 'enrollment')}>
                    {this.props.applicant.filename}
                  </span>
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <div style={{marginBottom: '14px'}}>
            <span>Breakdown of Fees</span>
            <Table unstackable celled size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>LEVEL</Table.HeaderCell>
                  <Table.HeaderCell>TUITION FEES</Table.HeaderCell>
                  <Table.HeaderCell>MISC FEES</Table.HeaderCell>
                  <Table.HeaderCell>BOOKS & MAGAZINES</Table.HeaderCell>
                  <Table.HeaderCell>TOTAL</Table.HeaderCell>
                  <Table.HeaderCell>SUBSIDY</Table.HeaderCell>
                  <Table.HeaderCell>TOTAL (TF, MISC, BOOKS)</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>{breakdownLevel.gradeLevel}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.tuition}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.misc}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.books}</Table.Cell>
                  <Table.Cell textAlign='right'>{breakdownLevel.total}</Table.Cell>
                  <Table.Cell textAlign='right' color='green'>{breakdownLevel.subsidy}</Table.Cell>
                  <Table.Cell textAlign='right'><strong>{breakdownLevel.grandTotal}</strong></Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
          <div style={{marginBottom: '14px'}}>
            <span>Payment Schedule</span>
            <Table unstackable celled size='small'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>LEVEL</Table.HeaderCell>
                  <Table.HeaderCell>PAYMENT SCHEDULE</Table.HeaderCell>
                  <Table.HeaderCell>UPON ENROLLMENT</Table.HeaderCell>
                  <Table.HeaderCell>NEXT PAYMENT</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>{scheduleOfPayment.gradeLevel}</Table.Cell>
                  <Table.Cell textAlign='right'>{this.props.applicant.paymentSchedule}</Table.Cell>
                  <Table.Cell textAlign='right'>{ue}</Table.Cell>
                  <Table.Cell textAlign='right'>{amt}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </Tab.Pane>
      },
      { menuItem: 'Outstanding Balance', render: () => <Tab.Pane>Under Development</Tab.Pane> },
      { menuItem: 'Classes', render: () => <Tab.Pane>Under Development</Tab.Pane> },
    ]
    return (
      <Modal
        trigger={
          <Popup
            on='hover'
            position='bottom center'
            size='tiny'
            trigger={
              <Button icon size='tiny' onClick={this.openModal}>
                <Icon name='eye' />
              </Button>
            }
          >
            View Applicant Details
          </Popup>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        size='fullscreen'
        closeIcon
        >
        <Modal.Header>View an Applicant</Modal.Header>
        <Modal.Content>
          <Segment>
          <div className='student-name-div'>
            <Icon name='user' size='large'/>
            <span className='student-name'>{this.props.applicant.lastName}, {this.props.applicant.firstName} ({this.props.applicant.nickName})</span>
            <span className='student-lrn'>Applicant #: {this.props.applicant.appNumber} </span> <br/>
            <span className='student-lrn'>LRN: {this.props.applicant.lrn? this.props.applicant.lrn : "--"} </span>
          </div>
          <Tab panes={panes} />
          </Segment>
        </Modal.Content>
        <Modal.Actions>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default ApplicantsView;
